export default __webpack_public_path__ + "static/media/question_09.7d3ecb40.png";